export default "__VITE_ASSET__f47eb540__"